import { NullAstVisitor } from '@angular/compiler';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Patient } from 'src/app/core/models/patient/patient';
import { PatientAddress } from 'src/app/core/models/patient/patientAddress';

@Component({
  selector: 'case-add-patient-dialog',
  templateUrl: './add-patient-dialog.component.html',
  styleUrls: ['./add-patient-dialog.component.scss']
})
export class AddPatientDialogComponent implements OnInit {
  sectionName:string="addPatient";
  patientdata:Patient=null;
  specialistId:number;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
  private dialogRef: MatDialogRef<AddPatientDialogComponent>,
  ) {}
  onConfirmClick(): void {
    this.dialogRef.close(true);
  }
  ngOnInit() {
  }
  togglePopUp(pdata:any){
console.log(pdata);
  }
}
